import { ExtendedOrderCollectionModel, ProductConfigDto, ResponseDto } from "@husky-hrc/Framework/Types/ApiModel";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";

export const productConfigUrl = "/api/v1/productconfig";
const ordersUrl = "/api/v1/orders";

export interface StartProductConfigurationApiV1Parameter extends ApiParameter {
    productId: string;
    configId: string;
}

export interface StepProductConfigurationApiV1Parameter extends ApiParameter {
    productId: string;
    configId: string;
    step: string;
}

export interface CommitProductConfigurationApiV1Parameter extends ApiParameter {
    productId: string;
    configId: string;
    value: string;
    parameter: string;
}

export interface CancelProductConfigurationApiV1Parameter extends ApiParameter {
    configId: string;
    productId: string;
}

export interface UncommitProductConfigurationApiV1Parameter extends ApiParameter {
    productId: string;
    configId: string;
    parameter: string;
}
export interface ResolveProductConfigurationApiV1Parameter extends ApiParameter {
    productId: string;
    configId: string;
    value: string;
    parameter: string;
}

type ExtendedGetOrderApiParameter = Omit<GetOrderApiParameter, "orderNumber"> & { orderNumber?: string };

export async function startNewProductConfiguration(parameter: StartProductConfigurationApiV1Parameter) {
    const productConfigDto = await post<StartProductConfigurationApiV1Parameter, ProductConfigDto>(
        `${productConfigUrl}/start/${parameter.productId}`,
    );
    return productConfigDto;
}

export async function startExistingProductConfiguration(parameter: StartProductConfigurationApiV1Parameter) {
    const productConfigDto = await get<ProductConfigDto>(`${productConfigUrl}/${parameter.configId}`);
    return productConfigDto;
}

export async function stepProductConfiguration(parameter: StepProductConfigurationApiV1Parameter) {
    const productConfigDto = await post<StepProductConfigurationApiV1Parameter, ProductConfigDto>(
        `${productConfigUrl}/step/${parameter.configId}/${parameter.step}`,
    );
    return productConfigDto;
}

export async function commitProductConfiguration(parameter: CommitProductConfigurationApiV1Parameter) {
    const productConfigDto = await post<CommitProductConfigurationApiV1Parameter, ProductConfigDto>(
        `${productConfigUrl}/commit/${parameter.configId}`,
        parameter,
    );
    return productConfigDto;
}

export async function cancelProductConfiguration(parameter: CancelProductConfigurationApiV1Parameter) {
    const responseDto = await post<CancelProductConfigurationApiV1Parameter, ResponseDto>(
        `${productConfigUrl}/cancel/${parameter.configId}`,
    );
    return responseDto;
}

export async function uncommitProductConfiguration(parameter: UncommitProductConfigurationApiV1Parameter) {
    const productConfigDto = await post<UncommitProductConfigurationApiV1Parameter, ProductConfigDto>(
        `${productConfigUrl}/uncommit/${parameter.configId}`,
        parameter,
    );
    return productConfigDto;
}

export async function resolveProductConfiguration(parameter: ResolveProductConfigurationApiV1Parameter) {
    const productConfigDto = await post<ResolveProductConfigurationApiV1Parameter, ProductConfigDto>(
        `${productConfigUrl}/accept/${parameter.configId}`,
        parameter,
    );
    return productConfigDto;
}

export async function getExtendedOrder(parameter: ExtendedGetOrderApiParameter): Promise<ExtendedOrderCollectionModel> {
    if (!parameter.orderNumber) {
        throw new Error("Order number is required");
    }

    const orderNumber = parameter.orderNumber;
    delete parameter.orderNumber;

    const extendedOrderCollection = await get<ExtendedOrderCollectionModel>(`${ordersUrl}/${orderNumber}/extended`);
    return extendedOrderCollection;
}
